import styled from 'styled-components'

import { ColumnFlex, FlexCentered } from 'components/common/genericStyles'

import { tabDesktopBreakpoint } from '../constants'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`

export const ViewScreen = styled.div`
    background: white;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 3;
    ${FlexCentered};
    flex-direction: column;
    border-radius: 8px 8px 0 0;
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        width: 98.46%;
        height: 97.12%;
        border-radius: 0;
    }
`

export const FlexLayout = styled.div`
    width: inherit;
    height: ${({ isTimerOver }) => (isTimerOver ? '70%' : 'inherit')};
    ${ColumnFlex}
    align-items: flex-start;
    justify-content: flex-start;
    overflow: hidden auto;
    padding: 12.22vh 6.66vw;
    @media (orientation: landscape) {
        height: ${({ isTimerOver }) => (isTimerOver ? '60%' : 'inherit')};
    }

    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        padding: 4.81% 4.05%;
        height: ${({ isTimerOver }) => (isTimerOver ? '70%' : 'inherit')};
    }
`

export const TimerWrapper = styled.div`
    position: absolute;
    right: 6.17vw;
    top: 3.33vh;

    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        right: 1.46vw;
        top: 2.24vh;
    }
`
